import { createAsyncThunk } from '@reduxjs/toolkit';
import GuildService from '../../../services/guild.service';
export const getMyGuild = createAsyncThunk('/guilds/my', async () => {
    try {
        return await GuildService.getMyGuilds();
    }
    catch (err) {
        return err.response;
    }
});
export const getAllGuilds = createAsyncThunk('/all/guilds', async (name) => {
    try {
        return await GuildService.getAllGuilds(name);
    }
    catch (err) {
        return err.response;
    }
});
export const getMembers = createAsyncThunk('/guilds/:id/members', async (id) => {
    try {
        return await GuildService.getMembers(id);
    }
    catch (err) {
        return err.response;
    }
});
export const createGuild = createAsyncThunk('/guilds/', async (data) => {
    try {
        const myGuild = await GuildService.createGuild(data.form);
        if (data.image) {
            await GuildService.uploadGuildImage({ guildId: myGuild.data.id, formData: data.image });
        }
        const allGuilds = await GuildService.getAllGuilds('');
        allGuilds.myGuild = myGuild;
        return allGuilds;
    }
    catch (err) {
        return err.response;
    }
});
export const editGuild = createAsyncThunk('/guilds/:id/edit', async (data) => {
    try {
        if (data.image) {
            await GuildService.uploadGuildImage({ guildId: data.id, formData: data.image });
        }
        return await GuildService.editGuild(data.id, data.form);
    }
    catch (err) {
        return err.response;
    }
});
export const requestGuild = createAsyncThunk('/guilds/:id/request', async (id) => {
    try {
        await GuildService.requestGuild(id);
        const members = await GuildService.getAllGuilds('');
        const getOne = await GuildService.getOneGuild(id);
        getOne.members = members;
        return getOne;
    }
    catch (err) {
        return err.response;
    }
});
export const joinGuild = createAsyncThunk('/guilds/:id/join', async (id) => {
    try {
        await GuildService.joinGuild(id);
        const members = await GuildService.getMembers(id);
        const getOne = await GuildService.getOneGuild(id);
        getOne.members = members;
        return getOne;
    }
    catch (err) {
        return err.response;
    }
});
export const leaveGuild = createAsyncThunk('/guilds/:id/leave', async (id) => {
    try {
        const myGuild = await GuildService.leaveGuild(id);
        const allGuilds = await GuildService.getAllGuilds('');
        allGuilds.myGuild = myGuild;
        return allGuilds;
    }
    catch (err) {
        return err.response;
    }
});
export const deleteGuild = createAsyncThunk('/guilds/:id/delete', async (id) => {
    try {
        await GuildService.deleteGuild(id);
        return await GuildService.getAllGuilds('');
    }
    catch (err) {
        return err.response;
    }
});
export const getOneGuild = createAsyncThunk('/guilds/:id', async (id) => {
    try {
        return await GuildService.getOneGuild(id);
    }
    catch (err) {
        return err.response;
    }
});
export const makeAdmin = createAsyncThunk('guilds/:guildId/make-admin/:userId', async (attr) => {
    try {
        await GuildService.makeAdmin(attr);
        return await GuildService.getMembers(attr.guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const revokeAdmin = createAsyncThunk('guilds/:guildId/revoke-admin/:userId', async (attr) => {
    try {
        await GuildService.revokeAdmin(attr);
        return await GuildService.getMembers(attr.guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const deleteUserFromGuildAction = createAsyncThunk('guilds/:guildId/delete/:userId', async (attr) => {
    try {
        await GuildService.deleteUserFromGuildAction(attr);
        return await GuildService.getMembers(attr.guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const banUser = createAsyncThunk('guilds/:guildId/ban/:userId', async (data) => {
    try {
        await GuildService.banUser(data.guildId, data.data);
        return await GuildService.getMembers(data.guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const activateUser = createAsyncThunk('guilds/:guildId/activate', async (data) => {
    try {
        await GuildService.activateUser(data.guildId, data.data);
        return await GuildService.getMembers(data.guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const makeNewOwner = createAsyncThunk('guilds/:id/leave-owner/:nextOwnerId', async (data) => {
    try {
        await GuildService.makeNewOwner(data);
        return await GuildService.getMembers(data.guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const deleteRequestGuild = createAsyncThunk('guilds/request/:id/delete', async (guildId) => {
    try {
        await GuildService.deleteRequestGuild(guildId);
        return await GuildService.getAllGuilds('');
    }
    catch (err) {
        return err.response;
    }
});
export const checkname = createAsyncThunk('guild/check-name', async (data) => {
    try {
        if (data.id) {
            return await GuildService.checkName(data.name, data.id);
        }
        return await GuildService.checkName(data.name);
    }
    catch (err) {
        return err.response;
    }
});
